import { isSSR } from '@front10/utils';
import { notifyFullMode } from './../../containers/_commons/navigation';

interface Props {
  interactionHotZone: FareItemInteractionHotZone;
  callToActionOnClick: (props: { data: FareItem }, label: string) => void;
  onClick?: $TSFixMe;
  showCallToAction: boolean;
  onKeyDown?: $TSFixMe;
  isIframe?: boolean;
  data: FareItem;
}

export function handleFareItemInteraction(props: Props) {
  const { interactionHotZone, callToActionOnClick, onClick, showCallToAction, isIframe } = props;
  const hasInteraction =
    interactionHotZone === 'whole' || (interactionHotZone === 'smart' && !showCallToAction);

  // This function is called when click in call to action button
  const handleCallToAction = (evt: Pick<MouseEvent, 'stopPropagation'>, label: string) => {
    if (!hasInteraction) {
      const callToActionLabel = label
        .split(' ')
        .map((l) => l[0].toUpperCase() + l.slice(1))
        .join('-');
      if (isIframe && !isSSR()) {
        notifyFullMode();
      }
      callToActionOnClick(props, callToActionLabel);
      evt.stopPropagation();
    }
  };

  // This function is called when click in whole card
  const handleClick = () => {
    if (hasInteraction) {
      if (isIframe && !isSSR()) {
        notifyFullMode();
      }
      callToActionOnClick(props, 'Fare-Card');
    } else {
      onClick?.(props);
    }
  };

  // This function is called when enter is pressed in focused card
  const handleItemKeyDown = (evt: React.KeyboardEvent) => {
    if (evt.key === 'Enter' || evt.keyCode === 13 || evt.keyCode === 32) {
      handleClick();
    } else if (typeof props.onKeyDown === 'function') {
      props.onKeyDown();
    }
    if (evt.keyCode === 32) {
      evt.preventDefault();
    }
    evt.stopPropagation();
  };

  // This function is called when enter is pressed in focused call to action
  const handleCallToActionKeyDown = (evt: React.KeyboardEvent, label: string) => {
    if (
      interactionHotZone !== 'smart' &&
      interactionHotZone !== 'button' &&
      (evt.key === 'Enter' || evt.keyCode === 13)
    ) {
      handleCallToAction(evt, label);
    }
    evt.stopPropagation();
  };

  return {
    hasInteraction,
    handleCallToAction,
    handleClick,
    handleItemKeyDown,
    handleCallToActionKeyDown
  };
}
